import { isDevelopmentEnv, isStagingEnv } from '@mc/client-env'
import { logger } from '@mc/next-logger'

/**
 * Safely removes a value from sessionStorage.
 * If sessionStorage is unavailable or an error occurs, the function does nothing.
 * Errors are only logged in development and staging environments.
 *
 * @param key - The key to remove from sessionStorage.
 */
export const safeRemoveSessionStorageItem = (key: string): void => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined')
    return

  try {
    sessionStorage.removeItem(key)
  } catch (err) {
    if (isDevelopmentEnv() || isStagingEnv()) {
      logger.error(`Error removing sessionStorage key "${key}":`, err)
    }
  }
}
